export default __webpack_public_path__ + "static/media/system_02_03.801be3ba.jpg";